import { render, staticRenderFns } from "./InstructionModal.vue?vue&type=template&id=4eedda54&"
import script from "./InstructionModal.vue?vue&type=script&lang=js&"
export * from "./InstructionModal.vue?vue&type=script&lang=js&"
import style0 from "./InstructionModal.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports